import { render } from "./DistributionGraph.vue?vue&type=template&id=6cbb0c14"
import script from "./DistributionGraph.vue?vue&type=script&lang=js"
export * from "./DistributionGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__